import { render, staticRenderFns } from "./UserManager.vue?vue&type=template&id=efaf3098&scoped=true"
import script from "./UserManager.vue?vue&type=script&lang=js"
export * from "./UserManager.vue?vue&type=script&lang=js"
import style0 from "./UserManager.vue?vue&type=style&index=0&id=efaf3098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efaf3098",
  null
  
)

export default component.exports